import { CircularProgress } from '@mui/material'


const LogoutOIDC = () => {
  return <div style={{ display:'flex' }}>
    <CircularProgress color='inherit' style={{ margin: '40px auto' }} disableShrink />
  </div>
}

export default LogoutOIDC
